var _path, _rect;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgTriangleDown = function SvgTriangleDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 25,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.979 6.45 13.5 24.6 3.021 6.45H23.98Z",
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 0.4
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 26.3,
    y: 9.3,
    width: 25.6,
    height: 4.6,
    rx: 0.8,
    transform: "rotate(-180 26.3 9.3)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.6
  })));
};

export default SvgTriangleDown;